// Resolves an RFM segment key to a translated label using literal i18n keys
// only, so it stays compatible with @intlify/vue-i18n/no-dynamic-keys.
export function segmentLabel(t, key) {
  switch (key) {
    case 'champions':
      return t('RFM.SEGMENTS.NAMES.CHAMPIONS');
    case 'loyal':
      return t('RFM.SEGMENTS.NAMES.LOYAL');
    case 'potential_loyalists':
      return t('RFM.SEGMENTS.NAMES.POTENTIAL_LOYALISTS');
    case 'new_customers':
      return t('RFM.SEGMENTS.NAMES.NEW_CUSTOMERS');
    case 'promising':
      return t('RFM.SEGMENTS.NAMES.PROMISING');
    case 'need_attention':
      return t('RFM.SEGMENTS.NAMES.NEED_ATTENTION');
    case 'at_risk':
      return t('RFM.SEGMENTS.NAMES.AT_RISK');
    case 'cant_lose':
      return t('RFM.SEGMENTS.NAMES.CANT_LOSE');
    case 'hibernating':
      return t('RFM.SEGMENTS.NAMES.HIBERNATING');
    case 'lost':
      return t('RFM.SEGMENTS.NAMES.LOST');
    case 'prospects':
      return t('RFM.SEGMENTS.NAMES.PROSPECTS');
    default:
      return key;
  }
}
